import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0089a188"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-content" }
const _hoisted_2 = {
  key: 0,
  class: "cover-loading"
}
const _hoisted_3 = { class: "content-wrap" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, "账单金额", -1))
const _hoisted_5 = { class: "price" }
const _hoisted_6 = { class: "qrcode-wrap" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, "请其他人用微信扫描以上二维码进行支付", -1))

import { Loading } from 'vant'
import { getWechatNativePay } from '@/apis/user'
import { showNormalToast, showToastLoading, clearToast } from '@/utils/tools'
import { withDefaults, ref, Ref, watch, computed } from 'vue'
import Qrcode from '@chenfengyuan/vue-qrcode'
import PopupCommonWrap from '@/components/popup/common-wrap.vue'
import CommonFooterNextButton from '@/components/CommonFooterNextButton.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'behalf-pay',
  props: {
    show: { type: Boolean, default: false },
    title: { default: '找人代付' },
    orderNo: { default: '' },
    behalfStatusCheckHandle: null
  },
  emits: ['update:show', 'paySuccess'],
  setup(__props: any, { emit: emits }) {

const props = __props as { show: boolean, title: string, orderNo: string, behalfStatusCheckHandle: (() => Promise<boolean>) | null };




const btnStyle = ref({
  backgroundColor: 'rgba(0,0,0,0.04)',
  color: '#00AF6C',
  border: 'none',
})
const timeId = ref(0)
const showCoverLoading = ref(false)
const orderNoMap: Ref<
  Record<
    string,
    {
      price: number
      code_url: string
    }
  >
> = ref({})
const currentInfo = computed(() => {
  return (
    orderNoMap.value[props.orderNo] || {
      code_url: '',
      price: 0,
    }
  )
})
watch(
  () => props.show,
  () => {
    if (props.show) {
      if (orderNoMap.value[props.orderNo]) {
        checkPayStatuasHandle()
      } else {
        getPayInfo()
      }
    }
    if (!props.show) {
      if (timeId.value) {
        // 清除轮询
        clearTimeout(timeId.value)
      }
    }
  }
)
function backHandle() {
  emits('update:show', false)
}
function updateShowHandle(value: boolean) {
  emits('update:show', value)
}
async function getPayInfo() {
  if (!props.orderNo) {
    showNormalToast('无支付订单号')
    return
  }
  showCoverLoading.value = true
  try {
    const data = await getWechatNativePay(props.orderNo)
    orderNoMap.value[props.orderNo] = {
      code_url: data.code_url,
      price: data.price,
    }
    checkPayStatuasHandle()
  } catch (error) {
    console.log('error', error)
  }
  showCoverLoading.value = false
}
async function checkPayStatuasHandle() {
  // 无感轮询，一旦检测支付成功则停止
  if (props.behalfStatusCheckHandle) {
    try {
      const bool = await props.behalfStatusCheckHandle()
      if (bool) {
        // 停止轮询
        timeId.value = 0
        emits('paySuccess')
        return
      }
    } catch (error) {
      console.log('error', error)
    }
  }
  timeId.value = setTimeout(() => {
    checkPayStatuasHandle()
  }, 5000)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PopupCommonWrap, {
    show: props.show,
    title: __props.title,
    teleport: "body",
    "onUpdate:show": updateShowHandle,
    headerStyle: {
      textAlign: 'center',
      backgroundColor: 'white',
    }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (showCoverLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_unref(Loading), {
                color: "#2d2d2d",
                type: "spinner"
              })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createTextVNode(" ￥"),
            _createElementVNode("span", null, _toDisplayString(_unref(currentInfo).price), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            (_unref(currentInfo).code_url)
              ? (_openBlock(), _createBlock(_unref(Qrcode), {
                  key: 0,
                  value: _unref(currentInfo).code_url,
                  options: {
              width: 160,
              margin: 1,
            }
                }, null, 8, ["value"]))
              : _createCommentVNode("", true)
          ]),
          _hoisted_7
        ]),
        _createVNode(CommonFooterNextButton, {
          title: "返回",
          onClick: backHandle,
          btnStyle: btnStyle.value
        }, null, 8, ["btnStyle"])
      ])
    ]),
    _: 1
  }, 8, ["show", "title"]))
}
}

})